<template>
  <div class="">
    <footer class="footer-area pt-5">
      <div class="container">
        <div class="row">
          <div class="col-sm-12 col-lg-6 pt-0 mt-0 text-center copyright-area">
            <p :style="($i18n.locale === 'ar') ? 'direction: rtl;' : ''">
            {{ $t('app.copyright') }} &copy; {{new Date().getFullYear()}} <a href="https://gatetechs.com/" style="color: #F7B933;" rel="noopener noreferrer" target="_blank">{{ $t('app.gatetechs') }}</a>
          </p>
          </div>
          <div class="col-sm-12 col-lg-6 text-center">
            <div class="footer-item">
              <div class="footer-logo">
                <ul>
                  <li>
                    <a href="http://gatetechs.com" target="_blank">
                      <i :class="'icofont-facebook'"></i>
                    </a>
                  </li>
                  <li>
                    <a href="http://gatetechs.com" target="_blank">
                      <i :class="'icofont-twitter'"></i>
                    </a>
                  </li>
                  <li>
                    <a href="http://gatetechs.com" target="_blank">
                      <i :class="'icofont-instagram'"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  components: {},
  data() {
    return {
      //
      settings: {
        phone: '',
        email: '',
        en: {
          address: '',
        },
        ar: {
          address: '',
        }
      },
      pgLoading: false,
      pages: [],
      supports: [],
    }
  },
  mounted() {
  },
  created() {
    //
    if (localStorage.getItem('settings.phone')) {
      this.settings.phone = localStorage.getItem('settings.phone');
    }
    if (localStorage.getItem('settings.email')) {
      this.settings.email = localStorage.getItem('settings.email');
    }

    if (localStorage.getItem('settings.en.address')) {
      this.settings.en.address = localStorage.getItem('settings.en.address');
    }
    if (localStorage.getItem('settings.ar.address')) {
      this.settings.ar.address = localStorage.getItem('settings.ar.address');
    }

    this.fetchPages();
    this.fetchSupports();
  },
  methods: {
    //

    fetchPages() {
      this.pgLoading = true;
      this.axios.defaults.headers.common = {
        'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + '/pages',
        method: 'GET',
        data: {},
        params: {
          ShowInFooter: true
        },
        headers: {
          appId: process.env.VUE_APP_APPID
        },
      }
      this.axios(options)
        .then(res => {
          this.pgLoading = false;
          this.pages = res.data.data.rows;
        })
        .catch(() => {
          //
        })
        .finally(() => {
        });
    },

    fetchSupports() {
      this.pgLoading = true;
      this.axios.defaults.headers.common = {
        'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + '/pages',
        method: 'GET',
        data: {},
        params: {
          ShowInSupport: true
        }
      }
      this.axios(options)
        .then(res => {
          this.pgLoading = false;
          this.supports = res.data.data.rows;
        })
        .catch(() => {
          //
        })
        .finally(() => {
        });
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footer-logo {
  text-align: -webkit-center;
}

.footer-logo ul {
  padding-right: 0 !important;
}
</style>
